module.exports = __webpack_public_path__ + "img/google-pay.2fed7850.png";